import { getFormattedLDFlags } from 'helpers/utils/getFormattedLDFlags';
import { resolvePlatform } from 'helpers/utils/resolvePlatform';

/**
 * `flowType` value for `virtualPageview` dataLayer pushes: the platform, the
 * allowlisted LaunchDarkly flags (see getFormattedLDFlags), and the LCE flag —
 * each as `key-value` pairs joined by ' | '.
 *
 * Shared by `useTrackPageRoute` (all routes) and `useHandoffPageview`
 * (retailerhandoff route) so the two pageview flavours can't drift.
 */
export function buildPageviewFlowType(flags?: Record<string, unknown> | null): string {
  const flagEntries = getFormattedLDFlags(flags);
  const lceFlagEntry =
    flags?.myAccountABTestUniversalApply !== undefined
      ? `myAccountABTestUniversalApply-${flags.myAccountABTestUniversalApply}`
      : '';
  return [resolvePlatform(), flagEntries, lceFlagEntry].filter(Boolean).join(' | ');
}
